import { render, staticRenderFns } from "./FeedBackForm.vue?vue&type=template&id=6a6266ca&scoped=true"
import script from "./FeedBackForm.vue?vue&type=script&lang=js"
export * from "./FeedBackForm.vue?vue&type=script&lang=js"
import style0 from "./FeedBackForm.vue?vue&type=style&index=0&id=6a6266ca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a6266ca",
  null
  
)

export default component.exports